<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                :to="`/unit/structure/officer/${$route.query.unit_id}?name${$route.query.unit_name}`"
                flat
                color="transparent"
                style="width: 20%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="amanata"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Tambah Pegawai
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                min-height="calc(100vh - 245px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text>
                  <v-row
                    justify="center">
                    <v-col
                      v-for="(item, index) in menu"
                      :key="index"
                      cols="2"
                      class="d-flex align-center justify-center px-0">
                      <v-divider
                        :style="selected.menu >= item.value && index > 0 ? `border-bottom: 2px solid ${set_color};` : index > 0 ? 'border-bottom: 2px solid #ebebeb;' : 'border: 0px solid #FFFFFF;'" />

                      <v-btn
                        @click="goToMenu(item.value)"
                        rounded
                        elevation="0"
                        :color="selected.menu >= item.value ? set_color : '#ebebeb'"
                        class="body-2 font-weight-bold text-capitalize white--text d-flex align-center pl-2 pr-3">
                        <v-avatar
                          size="24"
                          :color="selected.menu >= item.value ? 'green' : '#0000001a'">
                          <v-icon small v-if="selected.menu >= item.value">mdi-check-bold</v-icon>

                          <span v-else>
                            {{ item.value }}
                          </span>
                        </v-avatar>
                        
                        <span
                          class="ml-2">
                          {{ item.title }}
                        </span>
                      </v-btn>

                      <v-divider
                        :style="selected.menu > item.value && index < menu.length - 1 ? `border-bottom: 2px solid ${set_color};` : index < menu.length - 1 ? 'border-bottom: 2px solid #ebebeb;' : 'border: 0px solid #FFFFFF;'" />
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <Personal v-if="selected.menu === 1"
                        :form="form"
                        @step="selected.menu = $event" />

                      <Pegawai v-if="selected.menu === 2"
                        :form="form"
                        @step="selected.menu = $event" />

                      <Pelengkap v-if="selected.menu === 3"
                        :form="form"
                        @step="selected.menu = $event" />

                      <Dokumen v-if="selected.menu === 4"
                        :form="form"
                        @step="selected.menu = $event" />

                      <Keluarga v-if="selected.menu === 5"
                        :form="form"
                        @step="selected.menu = $event" />
                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col
              cols="12"
              md="2"
              class="py-0">
              <v-btn v-if="selected.menu > 1"
                to="/user"
                :disabled="process.form"
                block
                color="#212121"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center"
                style="border-radius: 10px; font-weight: 600;">
                <v-icon size="30">mdi-pan-left</v-icon>

                <span>
                  Kembali
                </span>
              </v-btn>
            </v-col>

            <v-col 
              cols="12"
              md="2"
              class="py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                block
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center"
                style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon v-if="selected.menu > 4"
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  :class="selected.menu > 4 ? 'ml-2' : ''">
                  {{ selected.menu < 5 ? 'Selanjutnya' : 'Simpan' }}
                </span>

                <v-icon v-if="selected.menu < 5"
                  size="30">
                  mdi-pan-right
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        selected: {
          menu: 1
        },
        
        menu: [
          {
            title: 'Data Personal',
            value: 1
          },
          {
            title: 'Data Pegawai',
            value: 2
          },
          {
            title: 'Data Pelengkap',
            value: 3
          },
          {
            title: 'Data Dokumen',
            value: 4
          },
          {
            title: 'Data Keluarga',
            value: 5
          }
        ],
        
        form: {
          username: '',
          code: '',
          name: '',
          unit_id: '',
          email: '',
          mobilephone: '',
          role: '',
          position_id: '',
          position: '',
          account_number: '',
          account_name: '',
          account_bank_name: '',
          gender: 'Laki-Laki',
          join_date: moment().format('YYYY-MM-DD'),
          address: '',
          blood_group: '',
          birthplace: '',
          birthdate: '',
          nik: '',
          npwp: '',
          bpjs_kes: '',
          bpjs_tk: '',
          jumlah_tanggungan: '',
          presensi_start_time: '',
          presensi_end_time: '',
          
          // username: 'qaireen',
          // code: '0003',
          // name: 'Qaireen Deanda Afsheen',
          // unit_id: '',
          // email: 'qaireen@gmail.com',
          // mobilephone: '081332051369',
          // role: 'admin',
          // position_id: 4,
          // position: 'Staff Manager',
          // account_number: '',
          // account_name: '',
          // account_bank_name: '',
          // gender: 'Laki-Laki',
          // join_date: '2023-09-02',
          // address: 'Klaten',
          // blood_group: '',
          // birthplace: 'Klaten',
          // birthdate: '1992-08-20',
          // nik: '',
          // npwp: '',
          // bpjs_kes: '',
          // bpjs_tk: '',
          // jumlah_tanggungan: '',
          // presensi_start_time: '',
          // presensi_end_time: ''
        },

        process: {
          form: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      Personal: () => import(/* webpackPrefetch: true */ '@/components/user/personal.vue'),
      Pegawai: () => import(/* webpackPrefetch: true */ '@/components/user/pegawai.vue'),
      Pelengkap: () => import(/* webpackPrefetch: true */ '@/components/user/pelengkap.vue'),
      Dokumen: () => import(/* webpackPrefetch: true */ '@/components/user/dokumen.vue'),
      Keluarga: () => import(/* webpackPrefetch: true */ '@/components/user/keluarga.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.selected.menu = this.$route.query.menu === undefined ? 1 : parseInt(this.$route.query.menu)
    },
    methods: {
      async goToMenu (val) {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {

          // SAVE TO REST API
          await post(`admin/user/add`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            if (res.status === 200) {
              this.selected.menu = val

              // this.$router.push({ path: `/user/edit/${res.results.data.id}`, query: { menu: this.selected.menu }})
              this.$router.push({ path: `/unit/structure/officer/user/edit/${res.results.data.id}`, query: { menu: this.selected.menu, unit_id: this.$route.query.unit_id, unit_name: this.$route.query.unit_name, position_id: this.$route.query.position_id, position_title: this.$route.query.position_title }})

              this.fetchCounter()
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/user/add`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {
              if (this.selected.menu < 5) {
                this.selected.menu += 1
  
                // this.$router.push({ path: `/user/edit/${res.results.data.id}`, query: { menu: this.selected.menu }})
                this.$router.push({ path: `/unit/structure/officer/user/edit/${res.results.data.id}`, query: { menu: this.selected.menu, unit_id: this.$route.query.unit_id, unit_name: this.$route.query.unit_name, position_id: this.$route.query.position_id, position_title: this.$route.query.position_title }})
              } else {
                // this.$router.push({ path: '/user' })
                this.$router.push({ path: `/unit/structure/officer/${this.$route.query.unit_id}`, query: { name: this.$route.query.unit_name }})
              }

              this.fetchCounter()
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async fetchCounter () {
        await get('admin/dashboard/counter')
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            let item = res.results.data

            let counter = {
              total_company_quota: item.total_company_quota,
              total_company_quota_used: item.total_company_quota_used,
              total_company_quota_sisa: item.total_company_quota - item.total_company_quota_used
            }

            TokenService.saveCounter(JSON.stringify(counter))

            this.$store.commit("setCounter", counter)
          }
        })
      }
    }
  }
</script>